// src/services/requireAuth.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "./authService";

const RequireAuth = ({ children }) => {
  const token = getToken();
  const location = useLocation();

  
  if (!token) {
    // 로그인 안돼있으면 로그인 페이지로 이동하면서 현재 위치 저장
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};



export default RequireAuth;
